import { resumePendingContinuation } from "./continueAfterAuth";
import { PWA_SHELL_STORAGE } from "./config";

let deferredPrompt = null;
const listeners = new Set();
let initialized = false;

export const getDeferredInstallPrompt = () => deferredPrompt;

export const clearDeferredInstallPrompt = () => {
	deferredPrompt = null;
	listeners.forEach((listener) => listener(null));
};

export const subscribeInstallPrompt = (listener) => {
	listeners.add(listener);
	listener(deferredPrompt);
	return () => listeners.delete(listener);
};

/**
 * Capture beforeinstallprompt early so it survives navigation to InstallPage.
 * Safe to call multiple times.
 * @returns {boolean} true when a pending resume already started location.replace
 */
export const initShellPwa = () => {
	if (typeof window === "undefined") return false;

	if (initialized) {
		return sessionStorage.getItem(PWA_SHELL_STORAGE.navLock) === "1";
	}
	initialized = true;

	// Installed PWA often opens at start_url "/" — resume the pending tool URL.
	const resumed = resumePendingContinuation();
	window.addEventListener("pageshow", () => resumePendingContinuation());
	window.addEventListener("focus", () => resumePendingContinuation());

	window.addEventListener("beforeinstallprompt", (event) => {
		event.preventDefault();
		deferredPrompt = event;
		listeners.forEach((listener) => listener(event));
	});

	window.addEventListener("appinstalled", () => {
		deferredPrompt = null;
		listeners.forEach((listener) => listener(null));
	});

	return resumed;
};
